// extracted by mini-css-extract-plugin
export default {"button":"style_button__hkj-V","slider":"style_slider__BzXIK","el":"style_el__fm1Tv","perspectiveText":"style_perspectiveText__gY3q5"};